import { put, select, takeLatest } from 'redux-saga/effects'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { IBodySurveyState, IExamValue, IExamValuePnnvs } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { saveBodySurvey, setExamPNNVValue, setExamValue } from '../store/bodySurvey.actions'
import { transformNeuroMentalData } from '../../../../../utilities/bodySurvey.util'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

const addUniqueValues = <T extends IExamValue | IExamValuePnnvs>(
  examValues: T[],
  segregatedValues: T[],
  filterFactor: keyof T
): T[] => {
  const uniqueValues = segregatedValues.filter(
    (presentValue) =>
      !examValues.some(
        (examValue) =>
          examValue[filterFactor] === presentValue[filterFactor] && examValue.locationId === presentValue.locationId
      )
  )

  return [...examValues, ...uniqueValues]
}

export function* updateExams() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)

  const { examValues, examValuesPNNVs, __examValues, __examValuesPNNVs } = bodySurvey

  let mentalModifiedOptions: IExamValue[] = []
  let mentalModifiedPnnvOptions: IExamValuePnnvs[] = []

  let neuroModifiedOptions: IExamValue[] = []
  let neuroModifiedPnnvOptions: IExamValuePnnvs[] = []

  try {
    let examValuesContainer: IExamValue[] = [...examValues]
    let examValuesPnnvsContainer: IExamValuePnnvs[] = [...examValuesPNNVs].map((value: IExamValue) => ({
      ...value,
      pn: '8801005',
    }))

    let dummyExamValues = [...__examValues]
    let dummyExamPnnvValues: IExamValuePnnvs[] = __examValuesPNNVs.map((value: IExamValue) => ({
      ...value,
      pn: '8801005',
    }))

    const mentalOptions = __examValues.filter((exam: IExamValue) => exam.locationId === 12)
    const mentalPnnvsOptions = __examValuesPNNVs.filter((exam: IExamValuePnnvs) => exam.locationId === 12)

    const neuroOptions = __examValues.filter((exam: IExamValue) => exam.locationId === 13)
    const neuroPnnvOptions = __examValuesPNNVs.filter((exam: IExamValuePnnvs) => exam.locationId === 13)

    const isNeuroMentalOption =
      mentalOptions.length > 0 ||
      mentalPnnvsOptions.length > 0 ||
      neuroOptions.length > 0 ||
      neuroPnnvOptions.length > 0

    if (mentalOptions.length > 0) {
      mentalModifiedOptions = transformNeuroMentalData('Mental', mentalOptions)
      dummyExamValues = [...mentalModifiedOptions]
    }
    if (mentalPnnvsOptions.length > 0) {
      mentalModifiedPnnvOptions = transformNeuroMentalData('Mental', mentalPnnvsOptions)
      dummyExamPnnvValues = [...mentalModifiedPnnvOptions] as IExamValuePnnvs[]
    }
    if (neuroOptions.length > 0) {
      neuroModifiedOptions = transformNeuroMentalData('Neuro', neuroOptions)
      dummyExamValues = [...neuroModifiedOptions]
    }
    if (neuroPnnvOptions.length > 0) {
      neuroModifiedPnnvOptions = transformNeuroMentalData('Neuro', neuroPnnvOptions)
      dummyExamPnnvValues = [...neuroModifiedPnnvOptions] as IExamValuePnnvs[]
    }
    const filterExamValuesForAbsent = examValuesContainer.filter(
      (item1) => !dummyExamPnnvValues.some((item2) => item1.id === item2.id)
    )

    const filterExamValuesPnnvsForPresent = examValuesPnnvsContainer.filter(
      (exam) => !dummyExamValues.some((presentVal) => exam.id === presentVal.id)
    )
    const filterFactor = isNeuroMentalOption ? 'customCommandFacId' : 'id'
    examValuesContainer = addUniqueValues(filterExamValuesForAbsent, dummyExamValues, filterFactor)
    examValuesPnnvsContainer = addUniqueValues(
      filterExamValuesPnnvsForPresent,
      dummyExamPnnvValues,
      filterFactor
    ) as IExamValuePnnvs[]
    yield put(setExamValue(examValuesContainer))
    yield put(setExamPNNVValue(examValuesPnnvsContainer))
    yield put(saveBodySurvey())
  } catch (e) {
    yield put(throwPcrException(`updateExams() error: ${e}`))
  }
}

export function* updateExamsSaga() {
  yield takeLatest(
    [BodySurveyConstants.UPDATE_EXAM_PNNV_VALUE, BodySurveyConstants.UPDATE_EXAM_VALUE],
    performWithMutexHOG,
    updateExams
  )
}
